import { render, staticRenderFns } from "./QnaReply.vue?vue&type=template&id=95e06d28&"
import script from "./QnaReply.vue?vue&type=script&lang=js&"
export * from "./QnaReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports